// extracted by mini-css-extract-plugin
export var photoViewer = "index-module--photoViewer--Eyuzc";
export var photoViewerStage = "index-module--photoViewerStage--1Ir26";
export var photoViewerSlide = "index-module--photoViewerSlide--3xu0o";
export var photoViewerDownload = "index-module--photoViewerDownload--1FSYH";
export var photoViewerActions = "index-module--photoViewerActions--3u7XK";